import React from 'react';

type DigitalRenewalEntryNotificationContent = {
    content: string;
    handleClick: () => void;
};
const DigitalRenewalEntryNotificationContent: React.FC<DigitalRenewalEntryNotificationContent> = ({
    content,
    handleClick,
}) => {
    const [beforeLink, linkText, linkTitle, afterLink] = content.split(/<a href='#'>|<\/a>/);
    return (
        <>
            <span dangerouslySetInnerHTML={{ __html: beforeLink }} />
            {/* eslint-disable-next-line */}
            <a href="#" title={linkTitle} onClick={() => handleClick()}>
                {linkText}
            </a>
            {afterLink}
        </>
    );
};

export default DigitalRenewalEntryNotificationContent;
